import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Stack, Typography, IconButton } from '@mui/material';
import { useNavigationStore } from '../../../../../store';
import {
  Background,
  Wrapper,
} from '@/components/navigation/NavigationIntroScreen/components/Popup/styles';
import DeviceManager from '@/components/util/deviceManager';
import { ChevronLeftIcon } from '@/components/navigation/NavigationIntroScreen/components/Popup/Icons';
import { ShareContainer } from '@/components/navigation/NavigationIntroScreen/components/Popup/components/ShareContainer';
import { navigationTranslationState } from '../../../../../store';
import { SharePopupProps } from './types';

const IMAGE_HEIGHT = 192;

export const NavigationSharePopup: React.FC<SharePopupProps> = (props) => {
  const {
    open,
    setOpen,
    setPopupHeight,
    popupTitle,
    qrEnabled,
    qrTitle,
    smsEnabled,
    smsTitle,
    smsText,
    target,
    startingPoint,
    rtl,
    country,
    policy,
  } = props;

  const [isVisible, setIsVisible] = useState(open);
  const textContainerRef = useRef<HTMLDivElement>(null);
  const titleContainerRef = useRef<HTMLDivElement>(null);
  const isMobile = DeviceManager.isMobile();

  const translation = useNavigationStore((state) => state.navigationTranslation);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (open) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [open]);

  useLayoutEffect(() => {
    const textHeight = textContainerRef.current?.offsetHeight;
    const titleHeight = titleContainerRef.current?.offsetHeight;
    const height = textHeight + titleHeight + IMAGE_HEIGHT;
    if (height) setPopupHeight(height);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return (
    <>
      <Background
        open={open}
        isVisible={isVisible}
        style={{
          background: 'none',
          backdropFilter: 'blur(0px)',
          position: 'static',
          marginTop: isMobile ? 'unset' : '',
          height: isMobile ? '100%' : 'auto',
          display: open ? '' : 'none',
          width: isMobile ? '100%' : 'fit-content',
        }}
      >
        <Wrapper
          open={open}
          onClick={(e) => e.stopPropagation()}
          style={{
            position: isMobile ? 'relative' : 'static',
            padding: '0px',
            width: isMobile ? 'auto' : '340px',
            height: isMobile ? '100%' : 'auto',
            border: isMobile ? 'none' : '1px solid #F7F7F7',
            transform: 'none',
            animation: 'none',
            marginLeft: isMobile ? '0' : '',
            background: isMobile ? 'none' : '#F7F7F7',
            borderRadius: '14px',
          }}
        >
          <Stack
            ref={titleContainerRef}
            sx={{
              p: '14px',
              background: '#F7F7F7',
              alignItems: 'center',
              justifyContent: { xs: 'center', sm: 'space-between' },
              borderBottom: '1px solid var(--Gray-300, #D0D5DD)',
              borderTopLeftRadius: '14px',
              borderTopRightRadius: '14px',
            }}
            direction="row"
          >
            <IconButton
              sx={{
                borderRadius: '1rem',
                padding: '4px',
                background: '#EAECF0',
                width: '32px',
                height: '32px',
                display: { xs: 'none', sm: 'inline-flex' },
              }}
              onClick={() => setOpen(false)}
            >
              <ChevronLeftIcon style={{}} />
            </IconButton>
            <Typography
              fontSize="16px"
              fontWeight={rtl ? 400 : 500}
              lineHeight="24px"
              sx={{ direction: rtl ? 'rtl' : 'ltr', color: '#000000' }}
            >
              {translation.navShareToPhone || 'Share to your phone'}
            </Typography>
            <IconButton
              sx={{
                width: '32px',
                height: '32px',
                color: 'black',
                fontSize: '16px',
                borderRadius: '1rem',
                marginRight: '5px',
                backgroundColor: '#eaecf0',
                visibility: 'hidden',
              }}
            >
              <i className="fa-solid fa-chevron-right" />
            </IconButton>
          </Stack>
          <Stack
            sx={{
              padding: '14px',
              background: '#F2F4F7',
              borderTop: '1px solid var(--Gray-200, #EAECF0)',
              borderBottomLeftRadius: '14px',
              borderBottomRightRadius: '14px',
            }}
          >
            <ShareContainer
              popupTitle={popupTitle}
              qrEnabled={qrEnabled}
              qrTitle={qrTitle}
              smsEnabled={smsEnabled}
              smsTitle={smsTitle}
              smsText={smsText}
              target={target}
              startingPoint={startingPoint}
              rtl={rtl}
              country={country}
              policy={policy}
            />
          </Stack>
        </Wrapper>
      </Background>
    </>
  );
};
